module.exports = __webpack_public_path__ + "static/media/whackavirus.94e4ceae.jpeg";